import { render } from "./DeleteRole.vue?vue&type=template&id=44d1dcb4"
import script from "./DeleteRole.vue?vue&type=script&lang=js"
export * from "./DeleteRole.vue?vue&type=script&lang=js"

import "./DeleteRole.vue?vue&type=style&index=0&id=44d1dcb4&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__